import React from "react";
import { CASE_STATUS, PRIORITY, TASK_STATUS } from "@/lib/constants";
import { AlertTriangle } from "lucide-react";

const Chip = ({ map, value, prefix = "", icon = null, testid }) => {
  const c = map[value] || { bg: "#F1F5F9", text: "#334155", border: "#CBD5E1" };
  return (
    <span data-testid={testid}
      className="inline-flex items-center gap-1 rounded-full border px-2.5 py-0.5 text-xs font-medium whitespace-nowrap"
      style={{ backgroundColor: c.bg, color: c.text, borderColor: c.border }}>
      {icon}{prefix}{value || "-"}
    </span>
  );
};

export const StatusBadge = ({ stato }) => (
  <Chip map={CASE_STATUS} value={stato} testid="case-status-badge" />
);

export const PriorityBadge = ({ priorita }) => (
  <Chip map={PRIORITY} value={priorita} prefix="Priorità: " testid="case-priority-badge"
    icon={priorita === "Urgente" ? <AlertTriangle className="h-3 w-3" /> : null} />
);

export const TaskStatusBadge = ({ stato }) => (
  <Chip map={TASK_STATUS} value={stato} testid="task-status-badge" />
);

// Badge di avanzamento pratica per la Dashboard, con regole colore richieste:
// Rosso = Urgente (override), Verde = Conclusa/Archiviata, Giallo = In lavorazione, Arancione = Assegnata
const DASH_COLORS = {
  green: { bg: "#EAF8F0", text: "#0B5D3B", border: "#BFEAD2" },
  yellow: { bg: "#FEF9C3", text: "#854D0E", border: "#FDE68A" },
  orange: { bg: "#FFF1E6", text: "#7A3E00", border: "#FFD2A8" },
  red: { bg: "#FEE4E2", text: "#7A271A", border: "#FECDCA" },
  neutral: { bg: "#F1F5F9", text: "#334155", border: "#CBD5E1" },
};

const dashTone = (stato, priorita) => {
  if (priorita === "Urgente") return "red";
  if (["Conclusa", "Archiviata"].includes(stato)) return "green";
  if (stato === "In lavorazione") return "yellow";
  if (stato === "Assegnata") return "orange";
  return "neutral";
};

export const DashboardCaseBadge = ({ stato, priorita }) => {
  const tone = dashTone(stato, priorita);
  const c = DASH_COLORS[tone];
  const urgent = priorita === "Urgente";
  return (
    <span data-testid="dashboard-case-badge"
      className="inline-flex items-center gap-1 rounded-full border px-2.5 py-0.5 text-xs font-medium whitespace-nowrap"
      style={{ backgroundColor: c.bg, color: c.text, borderColor: c.border }}>
      {urgent && <AlertTriangle className="h-3 w-3" />}
      {urgent ? `${stato} · Urgente` : (stato || "-")}
    </span>
  );
};
